module.exports = __webpack_public_path__ + "img/marvel.689c36e2.png";